module.exports = __webpack_public_path__ + "static/media/1906.0dd7eda4.png";